module.exports = __webpack_public_path__ + "img/t4-black.b5051649.png";